import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { exportReportText } from 'Const/report-attendance/text';
import getExportReportAttendanceHostDetail from 'Api/report-attendance-host-detail/getExportReportAttendanceHostDetail';

import getExportReportAttendanceHostDetailRequest from './model/request/getExportReportAttendanceHostDetailRequest';

const useGetExportReportAttendanceHostDetail = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });

      const params = getExportReportAttendanceHostDetailRequest(filter);

      const response = await getExportReportAttendanceHostDetail(params);

      return { response };
    },
    onSuccess: ({ response }) => {
      const filename = `Report Attendance Host Detail.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportReportAttendanceHostDetail;
